import { IPayloadAction } from 'store/type';
import { IProduct, IProductState, IPurchase } from './types';

export function setProducts(
    state: IProductState,
    action: IPayloadAction<IProduct[]>
): IProductState {
    return {
        ...state,
        products: action.payload,
    };
}

export function setPurchases(
    state: IProductState,
    action: IPayloadAction<IPurchase[]>
): IProductState {
    return {
        ...state,
        purchases: action.payload,
    };
}

export function addPurchase(
    state: IProductState,
    action: IPayloadAction<IPurchase>
): void {
    const updatedProduct = state.products
        .slice()
        .find(product => product.id === action.payload.product);
    if (updatedProduct) updatedProduct.purchases.push(action.payload.id);
}

export function removePurchase(
    state: IProductState,
    action: IPayloadAction<number>
): void {
    const updatedProduct = state.products.find(
        product => product.id === action.payload
    );
    if (updatedProduct) updatedProduct.purchases.splice(0, 1);
}
